/* eslint-disable import/prefer-default-export */
import _ from "lodash";

export function isStringArray(v: unknown): v is readonly string[] {
  return _.isArray(v) && _.every(v, _.isString);
}
